export const THEME_CLASSIFIER_MODAL_DATA = [
  {
    title: 'Бизнес и стартапы',
    description:
      'Каналы о бизнесе и стартапах, авторские блоги предпринимателей, бизнес-коучей, новости и тренды бизнес-сообществ'
  },
  {
    title: 'Блоги',
    description:
      'Личные блоги знаменитостей, журналистов, политических деятелей, профессиональные блоги (юристов, врачей и т.д.)'
  },
  {
    title: 'Видео и фильмы',
    description:
      'Блоги о кино, мультфильмах, сериалах, телепроектах: новинки, обсуждения, обзоры, фанатские каналы'
  },
  {
    title: 'Дизайн',
    description:
      'Каналы, посвященные графическому дизайну, фотошопу, моушн-дизайну, веб-дизайну, разработке логотипов и т.д.'
  },
  {
    title: 'Другое',
    description: 'Каналы, которые не вошли в остальные тематики классификатора'
  },
  {
    title: 'Еда и кулинария',
    description:
      'Блоги с рецептами, каналы ресторанов и фуд-блогеров, рестораторов, новости и тренды ресторанного бизнеса'
  },

  {
    title: 'Здоровье и Фитнес',
    description:
      'Блоги диетологов и нутрициологов, каналы, посвященные вопросам здоровья, правильному питанию, ЗОЖ, фитнесу и йоге, тренировкам'
  },
  {
    title: 'Игры',
    description:
      'Каналы, посвященные компьютерным и мобильным играм, блоги геймеров, новости индустрии'
  },
  {
    title: 'Интерьер и строительство',
    description:
      'Каналы застройщиков и агентств недвижимости, каналы, посвященные ремонту и дизайну, строительные и отделочные материалы'
  },
  {
    title: 'Искусство',
    description:
      'Каналы музеев, театров, художественных школ и галерей, фестивалей и выставок. Блоги деятелей искусства, каналы посвященные истории искусства и т.п.'
  },

  {
    title: 'Картинки и фото',
    description:
      'Каналы с обоями, фото, референсами под разные запросы, позингом, открытками и т.д.'
  },
  {
    title: 'Карьера',
    description:
      'HR-каналы и чаты, поиск сотрудников, каналы с вакансиями, предложениями по стажировкам, сообщества фрилансеров и т.п.'
  },

  {
    title: 'Книги',
    description:
      'Каналы книжных магазинов, издательств, электронных библиотек, авторов книг, а также каналы с литературными обзорами, рекомендациями'
  },
  {
    title: 'Криптовалюты',
    description:
      'Каналы сервисов по покупке и хранению криптовалюты, обучающие сообщества, новости рынка'
  },
  {
    title: 'Курсы и гайды',
    description: 'Каналы с курсами, лекциями, вебинарами, марафонами в разных сферах'
  },
  {
    title: 'Лингвистика',
    description:
      'Каналы языковых школ, преподавателей и репетиторов, сообщества посвященные изучению иностранных языков'
  },
  {
    title: 'Маркетинг, PR, реклама',
    description:
      'Блоги экспертов в маркетинге и рекламе, каналы егентств, сообщества, посвященные маркетингу, копирайтингу, аналитике'
  },
  {
    title: 'Медицина',
    description:
      'Фармацевтические каналы, каналы медицинских клиник, врачей, сообщества о разных направлениях медицины. Новости здравоохранения'
  },
  {
    title: 'Мода и красота',
    description:
      'Каналы косметических брендов и брендов одежды, магазинов, салонов красоты. Блоги бьюти- и фэшн-экспертов. Сообщества со скидками, референсами модных образов и т.д.'
  },
  {
    title: 'Музыка',
    description:
      'Блоги музыкальных исполнителей, фан-группы, каналы музыкальных сервисов, радиостанций и каналов, сообщества с музыкальными подборками, рекомендациями и т.п.'
  },

  {
    title: 'Новости и СМИ',
    description: 'Каналы федеральных и региоальных СМИ, новостные сообщества в разных сферах'
  },
  {
    title: 'Образование',
    description:
      'Каналы ВУЗов и других учебных заведений, новости образования, педагогические сообщества, блоги преподавателей, каналы, посвященные ОГЭ, ЕГЭ'
  },
  {
    title: 'Познавательное',
    description: 'Исторические и научные каналы, лайфхаки'
  },

  {
    title: 'Право',
    description:
      'Каналы региональных прокуратур, блоги юристов, адвокатов, правозащитников, каналы посвященные судебным практикам, международному праву'
  },
  {
    title: 'Природа',
    description: 'Каналы о природе, животных, рыбалке и охоте, дачной тематике'
  },

  {
    title: 'Продажи',
    description:
      'Официальные аккаунты маркетплейсов и магазинов разных тематик, торговых компаний, каналы со скидками, купонами и акциями. Также здесь частично представлены каналы по продаже недвижимости, в т.ч. за рубежом'
  },
  {
    title: 'Психология',
    description: 'Блоги психологов, сообщества, посвященные психологии'
  },

  {
    title: 'Путешествия',
    description:
      'Официальные аккаунты туроператоров, авиакомпаний, туристических агентств, сервисов бронирования и покупки билетов, блоги путешественников'
  },
  {
    title: 'Религия',
    description:
      'Блоги священнослужителей, каналы церквей, монастырей, сообщества, посвященные разным религиям'
  },

  {
    title: 'Рукоделие',
    description:
      'Каналы про раздичные виды рукоделия: шитье, вязание, игрушки и поделки своими руками, бисероплетение и т.д.'
  },
  {
    title: 'Семья и дети',
    description: 'Семейные блоги, каналы про воспитание, развитие'
  },
  {
    title: 'Софт и приложения',
    description: 'Каналы различных приложений, сервисов и о них'
  },
  {
    title: 'Спорт',
    description:
      'Каналы спортивных СМИ и проектов, букмекерских контор, официальные аккаунты команд из различных видов спорта, спортивных деятелей, а также сообщества спортивной тематики'
  },
  {
    title: 'Технологии',
    description:
      'Каналы и чаты на тему DevOps, разработки, языков программирования, нейросетей и т.п.'
  },
  {
    title: 'Транспорт',
    description:
      'Каналы дилеров, авторынков, автосервисов, магазинов автозапчастей. Сообщества, посвященные ПДД, грузоперевозкам, авиации, проишествиям на дорогах, новостям отрасли, чаты автомобилистов'
  },
  {
    title: 'Эзотерика',
    description:
      'Аккаунты астрологов, нумерологов, экстрасенсов. Каналы, посвященные астрологии, гороскопам, гаданиям, психодуховным практикам'
  },
  {
    title: 'Экономика',
    description:
      'Аккаунты банков, финансовых организаций. Блоги экономистов и трейдеров. Каналы, посвященные новостям экономики, инвестициям, бухгалтерии и т.д.'
  },
  {
    title: 'Юмор и развлечения',
    description: 'Юмористические паблики, каналы юмористических проектов, деятелей'
  }
]
